import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface BoatManufacturer {
  name: string;
  models: string[];
}

interface Engine {
  id: string;
  name: string;
}

interface Generator {
  id: string;
  name: string;
}

interface BoatDataSet {
  boatManufacturers: BoatManufacturer[];
}

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private boatData$ = new BehaviorSubject<BoatDataSet | null>(null);

  constructor(private http: HttpClient) {
    this.loadBoatData();
  }

  // Boat data access
  getBoatManufacturers(): Observable<string[]> {
    return this.boatData$.pipe(
      map(data => (data?.boatManufacturers || []).map(m => m.name))
    );
  }

  getModelsForMake(make: string): Observable<string[]> {
    return this.boatData$.pipe(
      map(data => {
        const manufacturer = (data?.boatManufacturers || []).find(m => m.name === make);
        return manufacturer?.models || [];
      })
    );
  }

  getEngines(): Observable<Engine[]> {
    return this.boatData$.pipe(map(() => []));
  }

  getGenerators(): Observable<Generator[]> {
    return this.boatData$.pipe(map(() => []));
  }

  // Firestore IDs access
  getSettingsId(type: 'app' | 'boat' | 'report' | 'preferences' | 'notifications'): string {
    const key = (type + 'Settings') as keyof typeof environment.firestoreIds;
    return environment.firestoreIds[key] || '';
  }

  // Private
  private loadBoatData(): void {
    this.http.get<BoatDataSet>('assets/boat-data.json').subscribe(
      data => this.boatData$.next(data),
      error => console.error('Failed to load boat data', error)
    );
  }
}
